import { AircraftLogEntryEditPage } from './AircraftLogEntryEditPage';
import { AircraftLogEntryAddPage } from './AircraftLogEntryAddPage';

export const AircraftLogEntryPage: React.FC<{aircraftId: string, noteId: string}> = ({ aircraftId, noteId }) => {
    if (noteId === 'add') {
        return <AircraftLogEntryAddPage aircraftId={aircraftId} />;
    } else {
        return <AircraftLogEntryEditPage aircraftId={aircraftId} noteId={noteId} />;
    }
};
